import React from 'react';
import {alpha, Box, Paper, Stack, Typography} from '@mui/material';
import {AutoAwesome, ChatBubbleOutline, Gavel, PersonOutline,} from '@mui/icons-material';

export default function RegulatoryQAVisual() {
    return (<Box
        sx={{
            width: '100%', height: '100%', minHeight: 260, p: 2, bgcolor: 'background.paper', display: 'flex', alignItems: 'center',
        }}
    >
        <Paper
            variant="outlined"
            sx={{
                width: '100%', borderRadius: 2.5, overflow: 'hidden', bgcolor: 'background.paper', boxShadow: '0 14px 28px rgba(15, 23, 42, 0.05)',
            }}
        >
            {/* Header */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider',
                }}
            >
                <Box>
                    <Typography variant="subtitle2" sx={{fontWeight: 800}}>
                        Regulatory Q&amp;A
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Product-aware regulatory guidance
                    </Typography>
                </Box>

                <Box
                    sx={{
                        px: 1.2, py: 0.5, borderRadius: 10, bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                    }}
                >
                    <Typography
                        variant="caption"
                        sx={{fontWeight: 800, color: 'primary.main'}}
                    >
                        Regulation linked
                    </Typography>
                </Box>
            </Stack>

            {/* Small context strip */}
            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{
                    px: 2, py: 1.25, borderBottom: '1px solid', borderColor: 'divider', bgcolor: (theme) => alpha(theme.palette.primary.main, 0.02), flexWrap: 'wrap', rowGap: 0.75,
                }}
            >
                <Gavel sx={{fontSize: 16, color: 'primary.main'}}/>
                <Typography variant="caption" color="text.secondary">
                    Greek Style Yogurt · Pectin (E440) · EU labelling context
                </Typography>
            </Stack>

            {/* Chat */}
            <Box sx={{p: 2}}>
                <Stack spacing={1.5}>
                    {/* User message */}
                    <Stack direction="row" spacing={1.2} alignItems="flex-start">
                        <Box
                            sx={{
                                width: 28, height: 28, borderRadius: '50%', bgcolor: (theme) => alpha(theme.palette.grey[500], 0.12), color: 'text.secondary', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: 0.4,
                            }}
                        >
                            <PersonOutline sx={{fontSize: 16}}/>
                        </Box>

                        <Paper
                            variant="outlined"
                            sx={{
                                px: 1.5, py: 1.2, borderRadius: 2, maxWidth: '85%', boxShadow: 'none',
                            }}
                        >
                            <Stack direction="row" spacing={1} alignItems="flex-start">
                                <ChatBubbleOutline
                                    sx={{fontSize: 16, color: 'primary.main', mt: 0.2}}
                                />
                                <Box>
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{display: 'block', mb: 0.4}}
                                    >
                                        User
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{fontWeight: 600, lineHeight: 1.5, fontSize: 14}}
                                    >
                                        Can pectin E440 be used as a stabiliser in this Greek Style
                                        Yogurt formulation?
                                    </Typography>
                                </Box>
                            </Stack>
                        </Paper>
                    </Stack>

                    {/* Assistant message */}
                    <Stack direction="row" spacing={1.2} alignItems="flex-start">
                        <Box
                            sx={{
                                width: 28, height: 28, borderRadius: '50%', bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12), color: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: 0.4,
                            }}
                        >
                            <AutoAwesome sx={{fontSize: 16}}/>
                        </Box>

                        <Paper
                            variant="outlined"
                            sx={{
                                px: 1.5, py: 1.3, borderRadius: 2, maxWidth: '88%', boxShadow: 'none', bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
                            }}
                        >
                            <Typography
                                variant="caption"
                                color="primary.main"
                                sx={{display: 'block', mb: 0.5, fontWeight: 800}}
                            >
                                Assistant
                            </Typography>

                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{
                                    display: 'block', fontSize: 11.5, fontWeight: 600, lineHeight: 1.5,
                                }}
                            >
                                <strong>Yes.</strong> For this Greek Style Yogurt, <strong>pectin (E440)</strong>{' '}
                                is a suitable stabiliser to improve body, reduce whey separation and support the
                                fruit phase.
                                <br/>
                                <br/>
                                The assistant maps it as a recognised additive and suggests the label wording{' '}
                                <strong>“stabiliser: pectin”</strong>. No formulation conflict is detected for
                                the current use level.
                            </Typography>
                        </Paper>
                    </Stack>
                </Stack>
            </Box>
        </Paper>
    </Box>);
}